import { render } from "./OrganicScoreGauge.vue?vue&type=template&id=fa575a12&scoped=true"
import script from "./OrganicScoreGauge.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganicScoreGauge.vue?vue&type=script&setup=true&lang=js"

import "./OrganicScoreGauge.vue?vue&type=style&index=0&id=fa575a12&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa575a12"],['__file',"resources/js/components/OrganicScoreGauge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa575a12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa575a12', __exports__)) {
    api.reload('fa575a12', __exports__)
  }
  
  module.hot.accept("./OrganicScoreGauge.vue?vue&type=template&id=fa575a12&scoped=true", () => {
    api.rerender('fa575a12', render)
  })

}


export default __exports__